import { FormGroup, Grid, TextField } from '@mui/material';
import maskCNPJ from '../../../../../components/Masks/maskCNPJ';

import React from 'react';

export default function LegalPerson(props) {
  const { formik } = props;
  return (
    <FormGroup style={{ width: '100%', marginTop: '10rem', position: 'relative' }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            id="formGridFarmName"
            label="Nome da fazenda"
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            inputProps={{ maxLength: 100 }}
            name="name"
            type="text"
            value={formik.values.name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.name && formik.errors.name}
            helperText={formik.touched.name && formik.errors.name}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            id="formGridOwner"
            label="Razão social"
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            name="owner"
            type="text"
            value={formik.values.owner}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.owner && formik.errors.owner}
            helperText={formik.touched.owner && formik.errors.owner}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            id="formGridCNPJ"
            className="formGridCNPJ"
            label="CNPJ"
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            name="cnpj"
            InputProps={{
              inputComponent: maskCNPJ,
            }}
            type="text"
            value={formik.values.cnpj}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.cnpj && !!formik.errors.cnpj}
            helperText={formik.touched.cnpj && formik.errors.cnpj}
          />
        </Grid>
      </Grid>
    </FormGroup>
  );
}
